<script setup>
import { useQuality } from '@/composables/useQuality'
import { useAbility } from '@casl/vue'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    layout: 'default',
    action: 'view',
    subject: 'Incident',
  },
})

const ability = useAbility()
const router = useRouter()
const { incidents, loading, fetchIncidents } = useQuality()

const status = ref('')

const load = () => fetchIncidents(status.value ? { status: status.value } : {})

onMounted(load)
watch(status, load)

const statusOptions = [
  { title: 'Semua', value: '' },
  { title: 'Dilaporkan', value: 'reported' },
  { title: 'Investigasi', value: 'investigating' },
  { title: 'Monitoring', value: 'monitoring' },
  { title: 'Ditutup', value: 'closed' },
]

const statusColor = value => ({
  reported: 'warning',
  investigating: 'info',
  monitoring: 'primary',
  closed: 'success',
}[value] ?? 'secondary')

const headers = [
  { title: 'No. IKP', key: 'incident_number', width: 180 },
  { title: 'Judul', key: 'title' },
  { title: 'Jenis', key: 'type' },
  { title: 'Unit', key: 'unit' },
  { title: 'Status', key: 'status', align: 'center', width: 140 },
]
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <div class="d-flex align-center justify-space-between flex-wrap gap-3">
          <div>
            <h4 class="text-h4 font-weight-bold">
              Insiden Keselamatan Pasien (IKP)
            </h4>
            <p class="text-body-2 text-medium-emphasis mb-0">
              Laporan → Investigasi → CAPA → Monitoring → Selesai (§9.4, BR-009)
            </p>
          </div>
          <VBtn
            v-if="ability.can('report', 'Incident')"
            prepend-icon="ri-add-line"
            @click="router.push({ name: 'quality-incidents-create' })"
          >
            Lapor Insiden
          </VBtn>
        </div>
      </VCol>
    </VRow>

    <VCard class="mb-4">
      <VCardText>
        <VSelect
          v-model="status"
          :items="statusOptions"
          label="Status"
          density="compact"
          style="max-width: 260px;"
        />
      </VCardText>
    </VCard>

    <VCard>
      <VDataTable
        :headers="headers"
        :items="incidents"
        :loading="loading"
        hide-default-footer
        @click:row="(e, { item }) => router.push({ name: 'quality-incidents-id', params: { id: item.id } })"
      >
        <template #item.incident_number="{ item }">
          <code>{{ item.incident_number }}</code>
        </template>
        <template #item.type="{ item }">
          {{ item.type?.name ?? '-' }}
        </template>
        <template #item.unit="{ item }">
          {{ item.unit?.name ?? '-' }}
        </template>
        <template #item.status="{ item }">
          <VChip
            size="small"
            :color="statusColor(item.status)"
            variant="tonal"
          >
            {{ item.status }}
          </VChip>
        </template>
        <template #no-data>
          <div class="text-center py-10">
            <p class="text-medium-emphasis">
              Belum ada insiden dilaporkan
            </p>
          </div>
        </template>
      </VDataTable>
    </VCard>
  </div>
</template>
